import { useQuery } from '@tanstack/react-query'
import { Link, useParams } from 'react-router'
import type { AccountDetail } from '../api/accounts'
import { api } from '../api/client'
import { AccessCard } from '../components/admin/accounts/AccessCard'
import { AdminFlagCard } from '../components/admin/accounts/AdminFlagCard'
import { DevicesCard } from '../components/admin/accounts/DevicesCard'
import { GrantsCard } from '../components/admin/accounts/GrantsCard'
import { PurchasesCard } from '../components/admin/accounts/PurchasesCard'
import { TimelineCard } from '../components/admin/accounts/TimelineCard'

/** One account for support: access and its sources, overrides, devices and the timeline. */
export function AccountDetailScreen() {
	const { id = '' } = useParams()
	const detail = useQuery({
		queryKey: ['admin-account', id],
		queryFn: () => api.get<AccountDetail>(`/api/v1/admin/accounts/${id}`),
	})

	return (
		<div className="stack">
			<div className="page-header">
				<div>
					<Link to="/admin?tab=accounts" className="small">
						← Accounts
					</Link>
					<h1 style={{ margin: '0.2rem 0 0', fontFamily: 'var(--mono)' }}>
						{detail.data?.account.supportId ?? 'Account'}
					</h1>
					<div className="muted small mono">{id}</div>
				</div>
			</div>
			{detail.isError && <p className="error">{detail.error.message}</p>}
			{detail.data && (
				<>
					<AccessCard detail={detail.data} />
					<AdminFlagCard accountId={id} />
					<PurchasesCard purchases={detail.data.purchases} />
					<GrantsCard accountId={id} grants={detail.data.grants} />
					<DevicesCard detail={detail.data} />
					<TimelineCard accountId={id} events={detail.data.events} />
				</>
			)}
		</div>
	)
}
